module.exports = __webpack_public_path__ + "static/media/logo.4c7aaf57.png";